const toAccountName = (email: string): string => email.split('@')[0] ?? email;

export {
  toAccountName,
};
